/* global gtag*/

import {gsap} from 'gsap';
import {$html} from '../../helpers/helpers';

export class Popup {
	constructor(popup, game) {
		this.game = game;
		this.popup = document.querySelector(popup);
		this.background = this.popup.querySelector('.popup__bg');
		this.button = this.popup.querySelector('.js-continue');
		this.open = true;
		this.buttonText = this.button.querySelector('.button__text');
		this.info = this.popup.querySelector('#start');
		this.starts = this.popup.querySelector('#stars');
		this.starsContent = this.starts.querySelectorAll('.popup__star');
		this.starsNames = this.starts.querySelectorAll('.popup__star .popup__star-name');
		this.starsContentIndexActive = 0;
		this.button.addEventListener('click', this.handler.bind(this));
		this.finalContent = this.popup.querySelector('#final');
		this.finalTitle = this.finalContent.querySelector('h2');
		this.finalText = this.finalContent.querySelector('p');
		this.btnReset = this.popup.querySelector('#reset');
		this.firstGameStart = true;

		this.btnReset.addEventListener('click', this.game.reset.bind(this.game));
	}

	handler() {
		const tl = gsap.timeline();

		if (this.open) {
			tl.to(this.popup, {
				duration: 0.3,
				opacity: 0,
				autoAlpha: 0,
				onComplete: () => {
					this.game.play();
					this.open = false;
					this.buttonText.textContent = 'продолжить';
					this.hideContent();
					$html.style.overflow = 'visible';

					// analytics
					if (this.firstGameStart) {
						// eslint-disable-next-line no-undef
						gtag('event', 'game_start_2');

						this.firstGameStart = false;
					}
				},
			});
		} else {
			tl.to(this.popup, {
				duration: 0.3,
				opacity: 1,
				autoAlpha: 1,
				onStart: () => {
					this.game.pause();
					this.open = true;
					$html.style.overflow = 'hidden';
				},
			});
		}
	}

	hideContent() {
		this.finalContent.style.display = 'none';
		this.info.style.display = 'none';
		this.starts.style.display = 'none';
		this.button.classList.remove('is-hidden');
		this.game.test.close();
	}

	openInfo() {
		this.info.style.display = 'block';

		this.handler();
	}

	openStarsContent() {
		if (!this.starsContentIndexActive) {
			this.starsContent[this.starsContentIndexActive].style.display = 'block';

			// analytics
			gtag('event', 'ambassador_popup_show', {
				event_label: this.starsNames[this.starsContentIndexActive].textContent,
			});

			this.starsContentIndexActive++;
		} else {
			this.starsContent[this.starsContentIndexActive - 1].style.display = 'none';
			this.starsContent[this.starsContentIndexActive].style.display = 'block';

			// analytics
			gtag('event', 'ambassador_popup_show', {
				event_label: this.starsNames[this.starsContentIndexActive].textContent,
			});
		}
	}

	openStars() {
		this.buttonText.textContent = 'идем дальше!';
		this.openStarsContent();
		this.starts.style.display = 'block';

		this.handler();
	}

	openFinal() {
		this.showFinalText();
		this.finalContent.style.display = 'block';
		this.button.classList.add('is-hidden');
		this.handler();

		// analytics
		gtag('event', 'game_finish', {
			event_label: this.game.score,
		});
	}

	reset() {
		this.handler();
		this.starsContentIndexActive = 0;
		this.starsContent.forEach((el) => {
			el.style.display = 'none';
		});

		// analytics
		gtag('event', 'game_resume');
	}

	setMetaForSharing(title, imageShare, description) {
		this.finalContent.querySelectorAll('[data-social]').forEach((btn) => {
			btn.dataset.params = `${title}, /images/share/${imageShare}, ${description}`;
		});
	}

	showFinalText() {
		if (this.game.score > this.game.maxScore - 20) {
			this.finalTitle.innerHTML = 'Ты&nbsp;прирожденный волонтер <br>и&nbsp;защитник природы!';
			this.finalText.innerHTML = 'Ты&nbsp;точно сможешь сделать берега водоемов России чище и&nbsp;красивее. Для этого у&nbsp;тебя есть и&nbsp;знания, и&nbsp;азарт. Осталось проявить их&nbsp;на&nbsp;практике. Присоединяйся к&nbsp;команде акции «Вода России»!';

			this.setMetaForSharing('Я — суперсила «Воды России»', 'share-1.png', 'Знаю все об очистке берегов рек и озер');
		} else if (this.game.score > this.game.maxScore - 40) {
			this.finalTitle.innerHTML = 'Ты&nbsp;на&nbsp;правильном пути!';
			this.finalText.innerHTML = 'Ты&nbsp;точно не&nbsp;из&nbsp;тех, кто после пикника бросит мусор на&nbsp;берегу реки или озера. Ты&nbsp;знаешь, чем опасно загрязнение природы. Пора сделать следующий шаг&nbsp;&mdash; присоединиться к&nbsp;тем, кто возвращает берегам чистоту. Стань волонтером акции «Вода России»!';

			this.setMetaForSharing('Я — надежда «Воды России»', 'share-2.png', 'Мусорить на берегу я точно не буду');
		} else {
			this.finalTitle.innerHTML = 'Ты&nbsp;сделал первый шаг!';
			this.finalText.innerHTML = 'Ты&nbsp;еще в&nbsp;самом начале пути, но&nbsp;ты&nbsp;идешь в&nbsp;правильном направлении! Готов изменить свои привычки и&nbsp;получить новые знания, чтобы сделать берега рек и&nbsp;озер чище. Так держать! Присоединяйся к&nbsp;команде волонтеров акции «Вода России»!';

			this.setMetaForSharing('Я — новичок «Воды России»', 'share-3.png', 'Мечтаю сделать берега рек и озер чище и красивее');
		}
	}
}
